import GroupInfoFormValidation from "@usas/ui-web/components/forms/groups/GroupInfoFormValidation";
import ClubSiteAttributesFormValidation from "@usas/ui-web/components/forms/groups/ClubSiteAttributesFormValidation";

const ClubGroupTypeSiteValidation = async (formState) => {
  let errors = {
    ...GroupInfoFormValidation(formState),
    ...ClubSiteAttributesFormValidation(formState)
  };

  return errors ? errors : {};
};

export default ClubGroupTypeSiteValidation;